import {Component, Input, ViewEncapsulation} from "@angular/core";

@Component({
  selector: 'pl-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: [ './pop-up.component.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class PopUpComponent { }
